export const chartColorsNOKDay ={
    A:   '#FBCEB1',
    B:   '#800080',
    C:   '#FFFF00',
    D:   '#808000',
    E:   '#DC143C',
    F:   '#C0C0C0',
    G:   '#32CD32',
    H:   '#808080',
    I:   '#20B2AA',
    J:   '#C71585',
    K:   '#F5F5DC',
    L:   '#008B8B',
    M:   '#FF0000',
    N:   '#87CEEB',
    O:   '#FA8072',
    P:   '#FF7F00',
    Q:   '#4B0082',
    R:   '#000080',
    S:   '#008000',
    T:   '#E6E6FA',
    U:   '#00FFFF',
    V:   '#8B4513',
    W:   '#FF69B4',
    X:   '#00CED1',
    Y:   '#FFD700',
    Z:   '#0000FF',
    AA:   '#FBCEB1',
    AB:   '#800080',
    AC:   '#FFFF00',
    AD:   '#808000',
    AE:   '#DC143C',
    AF:   '#C0C0C0',
    AG:   '#32CD32',
    AH:   '#808080',
    AI:   '#20B2AA',
    AJ:   '#C71585',
    AK:   '#F5F5DC',
    AL:   '#008B8B',
    AM:   '#FF0000',
    AN:   '#87CEEB',
    AO:   '#FA8072',
    AP:   '#FF7F00',
    AQ:   '#4B0082',
    AR:   '#000080',
    AS:   '#008000',
    AT:   '#E6E6FA',
    AU:   '#00FFFF',
    AV:   '#8B4513',
    AW:   '#FF69B4',
    AX:   '#00CED1',
    AY:   '#FFD700',
    AZ:   '#0000FF',
    a:   '#FBCEB1',
    b:   '#800080',
    c:   '#FFFF00',
    d:   '#808000',
    e:   '#DC143C',
    f:   '#C0C0C0',
    g:   '#32CD32',
    h:   '#808080',
    i:   '#20B2AA',
    j:   '#C71585',
    k:   '#F5F5DC',
    l:   '#008B8B',
    m:   '#FF0000',
    n:   '#87CEEB',
    o:   '#FA8072',
    p:   '#FF7F00',
    q:   '#4B0082',
    r:   '#000080',
    s:   '#008000',
    t:   '#E6E6FA',
    u:   '#00FFFF',
    v:   '#8B4513',
    w:   '#FF69B4',
    x:   '#00CED1',
    y:   '#FFD700',
    z:   '#0000FF',
    aa:   '#FBCEB1',
    ab:   '#800080',
    ac:   '#FFFF00',
    ad:   '#808000',
    ae:   '#DC143C',
    af:   '#C0C0C0',
    ag:   '#32CD32',
    ah:   '#808080',
    ai:   '#20B2AA',
    aj:   '#C71585',
    ak:   '#F5F5DC',
    al:   '#008B8B',
    am:   '#FF0000',
    an:   '#87CEEB',
    ao:   '#FA8072',
    ap:   '#FF7F00',
    aq:   '#4B0082',
    ar:   '#000080',
    as:   '#008000',
    at:   '#E6E6FA',
    au:   '#00FFFF',
    av:   '#8B4513',
    aw:   '#FF69B4',
    ax:   '#00CED1',
    ay:   '#FFD700',
    az:   '#0000FF'
};